import { defaultSchema } from 'rehype-sanitize';

export const safeSchema = {
  ...defaultSchema,
  tagNames: [...(defaultSchema.tagNames || []), 'b', 'i', 'em', 'strong', 'br', 'code', 'tooltip'],
  attributes: {
    ...defaultSchema.attributes,
    // a: ['href', 'title'], // only allow safe attributes for <a>
  },
};
